// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","popup":"_1j5C","active":"_3uBI","inputRow":"_3kSh"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/SelectPretty/SelectPretty.scss
// module id = HF9j
// module chunks = 0